import { Outlet, useNavigate } from 'react-router-dom';


import DashboardSidebar from "../../layout/DashboardSidebar";
import React, { useState } from 'react'
// import "./sidebar.css";


import { Modal } from "react-bootstrap";
import { sidebarData, sidebarDataa } from './EmpSidebar';


const EmpPage = () => {
    const userProfilepic = sessionStorage.getItem('profilepic');
    console.log(userProfilepic);
    console.log(sessionStorage.getItem('profilepic'));
    const isExpanded = sessionStorage.getItem("isExpanded")
    console.log(isExpanded)


    const [isexpand, setExpanded] = useState(true);
    const [isHovered, setIsHovered] = useState(false);


    console.log(isexpand)



    const [show, setShow] = useState(false); //Announcement Notify

    const handleClose = () => setShow(false);
    const navigate = useNavigate();



    const [showttext, Setshowtext] = useState(false)

    const handleopen = () => Setshowtext(true);
    const handleclosetext = () => Setshowtext(false);
    return (
        <>


            <div className="dashboard-main-section" style={{ marginLeft: (!isexpand && !isHovered) && "74px" }}>
                <DashboardSidebar sidebarData={sidebarData} isExpanded={isexpand} setIsExpanded={setExpanded} isHovered={isHovered} setIsHovered={setIsHovered} />
                <div className={(isexpand || isHovered) ? "dashboard-main-content-sectionnn" : "expandWidth"} style={{ width: "100%" }}>

                    <Outlet />


                </div>


            </div>
        </>
    );
};


export default EmpPage;
